<style lang="scss" src='./Reports.scss'></style>
<template src="./Reports.html"></template>

<script>
import SecurityComponent from '@/components/SecurityComponent.vue';
import SensorAlerts from './components/sensorAlerts/SensorAlerts.vue';
import WeatherAlerts from './components/weatherAlerts/WeatherAlerts.vue';
import Sensors from './components/sensors/Sensors.vue';
import WeatherStations from './components/weatherStations/WeatherStations.vue';
import OpUsersReport from './components/opUsersReport/opUsersReport.vue';
import OpSensorInventory from './components/opSensorInventory/opSensorInventory.vue';
import LocalWeather from './components/localWeather/LocalWeather.vue'

export default {
  name: "Reports",
  mounted() {
    if (process.env.VUE_APP_SENTRY_ENV == "production") {
      this.$analytics.setCurrentScreen("Web Reports");
      this.$analytics.logEvent("web_reports");
    }
  },
  extends: SecurityComponent,
  components: {
    SensorAlerts,
    WeatherAlerts,
    Sensors,
    WeatherStations,
    OpUsersReport,
    OpSensorInventory,
    LocalWeather,
  },
  data() {
    return {
      tabs: this.getTabs(),
      currentTab: '',
    };
  },

  methods: {
    linkClass(idx) {
    
      return ['tab-btn-wrapper']
    
    },

    canShowTab(tabName){
      
      if(tabName.substr(0,3) === 'OP-'){
        return (this.$store.state.user.user_type.type_id == this.consts.UserType.ADMIN || this.$store.state.user.user_type.type_id == this.consts.UserType.OPERATIONS);
      }else{
        return true;
      }
      
    }
  },

  mounted() {
  },

};
</script>
